import React, { useEffect } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { compose } from 'recompose';
import { ApplicationState } from 'src/store/ApplicationState';
import { pathOr, isEmpty } from 'ramda';
import { ThemeProvider } from 'src/components/core/styles';
import { hexToHSL, setTheme } from 'src/utilities/theme';
import { loadThemes } from './theme_mui';
import SiteSettings from 'src/siteSetting';
interface Props {
  children: any;
}

type CombinedProps = Props & StateProps;

const AppThemeWrapper: React.FC<CombinedProps> = (props: CombinedProps) => {

  const { children, siteSettings } = props;

  useEffect(() => {
    const primaryColor = SiteSettings.mainColor();
    const secondaryColor = SiteSettings.secondaryColor()

    if (!isEmpty(primaryColor)) {
      setTheme(hexToHSL(primaryColor), secondaryColor);
    }
  }, [siteSettings]);

  return (
    <MemoizedThemeProvider>
      {children}
    </MemoizedThemeProvider>
  );
};
interface MemoizedThemeProviderProps {
  children: any;
}

const MemoizedThemeProvider: React.FC<MemoizedThemeProviderProps> = (props) => {
  const { children } = props;
  return (
    <ThemeProvider theme={loadThemes(SiteSettings)}>
      {children}
    </ThemeProvider>
  );
};

interface StateProps {
  siteSettings: any;
}

const mapStateToProps: MapStateToProps<StateProps, {}, ApplicationState> = (
  state
) => ({
  siteSettings: pathOr({}, ['__resources', 'siteSettings', 'data'], state),
});

const connected = connect(mapStateToProps, undefined);
const enhanced = compose(connected);

export default enhanced(AppThemeWrapper);
